import { useStore } from "vuex";

// Allows passing cart as a parameter (for use after the shopping cart store is cleared upon order completed).
// Otherwise, it reads the shopping cart store directly.
export function useHardwareCartItems(cart?: any[]) {
	const store = useStore();

	const hardwareProducts = computed<any[]>(() =>
		(cart || store.getters["shoppingCart/visibleCartItems"])
			.map((item: { subItems: any }) => [item, ...(item?.subItems ?? [])])
			.flat()
			.filter((item: { type: string }) => item?.type === "hardware"),
	);

	return { hardwareProducts };
}
